import add from './add'
import rename from './rename'

export const sites = {
  add,
  rename,
}
